import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import FastTextArea from '../util/FastTextArea';
import FastFormQuestion from "../util/FastFormQuestion";
import FORM_QUESTIONS from '../../step5_tab1_questions.json';

import { SECOND_ROUND_DROPDOWN_ACTIVE } from '../../fastConstants.js';

export default function PlanChangesForm(props) {
    let programId = props.selectedProgram?.programId
    let sloId = props.selectedLearningOutcome?.sloId

    let step2Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    if (programId in props.step2DataStore) {
        let step2DataBySlo = props.step2DataStore[programId]
        if (sloId in step2DataBySlo) {
            step2Data = step2DataBySlo[sloId]
        }
    }

    let step4Data = {
        summaryOfResults: "",
        reflectionOnHypothesis: "",
        interpretationOfResults: "",
        followUpQuestions: "",
        actionsForImprovement: "",
    }
    if (programId in props.step4DataStore) {
        let step4DataBySlo = props.step4DataStore[programId]
        if (sloId in step4DataBySlo) {
            step4Data = step4DataBySlo[sloId]
        }
    }

    const isStepComplete = () => {
        if (props.stepCompletionData && props.selectedProgram) {
            return props.stepCompletionData[props.selectedProgram.programId].completed
        }
        return false
    }
    
    return (
        <React.Fragment>
            <Form>
                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Department
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.department.name}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Program
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.selectedProgram?.name}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Theme
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8">
                            {props.theme ? props.theme.name : 'Unavailable'}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Learning Outcome
                    </Form.Label>
                    <Col sm="8">
                        <Form.Select 
                            aria-label="Select Learning Outcome"
                            onChange={props.handleLearningOutcomeChanged}
                            name={'program-' + props.selectedProgram?.programId + '_slo-' + props.selectedLearningOutcome?.sloId}
                            value={props.selectedLearningOutcome?.sloId}
                            >
                            { props.selectedProgram &&
                                props.learningOutcomes[props.selectedProgram.programId].map((slo, key) => 
                                    <option key={key} value={slo.sloId}>{slo.text}</option>
                                )
                            }
                        </Form.Select>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Focus Area
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                        { props.selectedProgram &&
                            props.step1DataStore[props.selectedProgram.programId][props.selectedLearningOutcome?.sloId]?.s1q1}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Description of Tool
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step2Data.toolDescription}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Course(s) Assessed
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step2Data.coursesAssessed}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Results from first data collection
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step4Data.summaryOfResults}
                        </Form.Label>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="4">
                        Interpretation of results
                    </Form.Label>
                    <Col sm="8">
                        <Form.Label column sm="8" className="w-100">
                            {step4Data.interpretationOfResults}
                        </Form.Label>
                    </Col>
                </Form.Group>
                { SECOND_ROUND_DROPDOWN_ACTIVE &&
                <Form.Group as={Row} className="mb-3" controlId="assessment_barriers">
                    <Form.Label column sm="4" className="align-self-start">
                        <FastFormQuestion
                            text={FORM_QUESTIONS["cycleSecondDataCollection"].text}
                            required={FORM_QUESTIONS["cycleSecondDataCollection"].required}
                            inline={false}
                            />
                    </Form.Label>
                    <Col sm="8" className="pt-3">
                        <Form.Select
                            name="cycleSecondDataCollection"
                            aria-label="Assessment Barriers"
                            value={props.stepData.s5q30}
                            onChange={props.handleS5Q30Changed}
                            disabled={isStepComplete()}
                            >
                            <option name=""></option>
                            <option value="yes">Yes</option>
                            <option value="no1">No - focusing on other outcomes this cycle</option>
                            <option value="no2">No - course(s) aligned with this outcome are not offered again during this cycle</option>
                            <option value="no3">No - program is in transition</option>
                            <option value="no4">No - sufficient evidence was collected in the first round</option>
                        </Form.Select>
                    </Col>
                </Form.Group>
                }
                
                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["changesPlanned"].text}
                            required={FORM_QUESTIONS["changesPlanned"].required}
                            inline={true}
                            />
                        <span className="text-muted">
                            What is the department going to do to try to improve outcomes based on these results?
                        </span>
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s5q1"
                            callback={props.handleS5Q1Changed}
                            text={props.stepData.s5q1}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="2048"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["dataMotivatedChanges"].text}
                            required={FORM_QUESTIONS["dataMotivatedChanges"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s5q2"
                            callback={props.handleS5Q2Changed}
                            text={props.stepData.s5q2}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="1024"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["hypothesisAboutChanges"].text}
                            required={FORM_QUESTIONS["hypothesisAboutChanges"].required}
                            inline={true}
                            />
                        <span className="text-muted">
                        How will the planned changes help improve outcomes?
                        </span>
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s5q3"
                            callback={props.handleS5Q3Changed}
                            text={props.stepData.s5q3}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="1024"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["changeInApproach"].text}
                            required={FORM_QUESTIONS["changeInApproach"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s5q4"
                            callback={props.handleS5Q4Changed}
                            text={props.stepData.s5q4}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="1024"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["facultyInvolved"].text}
                            required={FORM_QUESTIONS["facultyInvolved"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <FastTextArea
                            id="s5q5"
                            callback={props.handleS5Q5Changed}
                            text={props.stepData.s5q5}
                            rows="3"
                            disabled={props.formDisabled}
                            maxLength="1024"
                            />
                    </Row>
                </Form.Group>

                <Form.Group as={Col} className="mb-3" controlId="describe_analyze_g1">
                    <Form.Label column sm="12">
                        <FastFormQuestion 
                            text={FORM_QUESTIONS["typeOfChanges"].text}
                            required={FORM_QUESTIONS["typeOfChanges"].required}
                            />
                    </Form.Label>
                    <Row sm="12">
                        <Col sm="6">
                            <Form.Check
                                type="checkbox"
                                id="s5q6"
                                name="s5q6"
                                label="Change in teaching approach"
                                onClick={props.handleS5Q6Changed}
                                checked={props.stepData.s5q6}
                                disabled={props.formDisabled}
                                />
                            <Form.Check
                                type="checkbox"
                                id="s5q7"
                                name="s5q7"
                                label="Faculty training/development"
                                onClick={props.handleS5Q7Changed}
                                checked={props.stepData.s5q7}
                                disabled={props.formDisabled}
                                />
                            <Form.Check
                                type="checkbox"
                                id="s5q8"
                                name="s5q8"
                                label="Change in course content"
                                onClick={props.handleS5Q8Changed}
                                checked={props.stepData.s5q8}
                                disabled={props.formDisabled}
                                />
                            <Form.Check
                                type="checkbox"
                                id="s5q9"
                                name="s5q9"
                                label="Change in course sequence/prerequisites"
                                onClick={props.handleS5Q9Changed}
                                checked={props.stepData.s5q9}
                                disabled={props.formDisabled}
                                />
                        </Col>
                        <Col sm="6">
                            <Form.Check
                                type="checkbox"
                                id="s5q10"
                                name="s5q10"
                                label="Grading Methodology changes"
                                onClick={props.handleS5Q10Changed}
                                checked={props.stepData.s5q10}
                                disabled={props.formDisabled}
                                />
                            <Form.Check
                                type="checkbox"
                                id="s5q11"
                                name="s5q11"
                                label="Assignment revision"
                                onClick={props.handleS5Q11Changed}
                                checked={props.stepData.s5q11}
                                disabled={props.formDisabled}
                                />
                            <Form.Check
                                type="checkbox"
                                id="s5q12"
                                name="s5q12"
                                label="Budgetary reallocation"
                                onClick={props.handleS5Q12Changed}
                                checked={props.stepData.s5q12}
                                disabled={props.formDisabled}
                                />
                            <Form.Check
                                type="checkbox"
                                id="s5q13"
                                name="s5q13"
                                label="Other"
                                onClick={props.handleS5Q13Changed}
                                checked={props.stepData.s5q13}
                                disabled={props.formDisabled}
                                />
                        </Col>
                    </Row>
                </Form.Group>
            </Form>
        </React.Fragment>
    )
}